import * as ko from "knockout";
import {BaseProperty, IPropertyDescription} from "Core/GeneralProperties/Managers/BaseProperty";

import InputNumberPropertyTemplate from "Core/GeneralProperties/Managers/InputNumberProperty/Templates/InputNumberProperty.html";

ko.templates["Core/GeneralProperties/Managers/InputNumberProperty/Templates/InputNumberProperty"] = InputNumberPropertyTemplate;

export class InputNumberProperty extends BaseProperty {
    private _maxValue: number;
    private _minValue: number;
    constructor(property: IPropertyDescription, propertyValue: number) {
        super(property);
		this.Value = ko.observable(propertyValue || this.GetDefaultValue());
        this._maxValue = property.MaxValue ?? Infinity;
        this._minValue = property.MinValue ?? -Infinity;

         this.Value.subscribe(val => {
            const max = this._maxValue;
            const min = this._minValue;
            if (val < min) this.Value(min);
            if (val > max) this.Value(max);
        });
    }

    GetTemplateName(): string {
        return "Core/GeneralProperties/Managers/InputNumberProperty/Templates/InputNumberProperty";
    }

    SetValue(propertyValue: number): void {
        if (propertyValue) {
            this.Value(propertyValue);
        }
    }

    GetDefaultValue() {
        return 0;
    }
}